import { motion } from "framer-motion";

/**
 * Reveal — wraps children with a scroll-triggered fade/translate animation.
 * Respects prefers-reduced-motion implicitly (Framer Motion honors it).
 *
 * Props:
 *   direction — "up" | "down" | "left" | "right" | "fade"    (default "up")
 *   delay     — seconds to delay the start of the animation  (default 0)
 *   amount    — viewport intersection ratio before triggering (default 0.18)
 *   once      — animate once (default true)
 *   as        — element/component to render (default "div")
 *   className — passed through
 */
const OFFSETS = {
  up: { x: 0, y: 24 },
  down: { x: 0, y: -24 },
  left: { x: 24, y: 0 },
  right: { x: -24, y: 0 },
  fade: { x: 0, y: 0 },
};

export default function Reveal({
  children,
  direction = "up",
  delay = 0,
  amount = 0.18,
  once = true,
  className = "",
  ...rest
}) {
  const offset = OFFSETS[direction] || OFFSETS.up;
  return (
    <motion.div
      initial={{ opacity: 0, ...offset }}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once, amount }}
      transition={{ duration: 0.55, ease: "easeOut", delay }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}
